import combineBenchlingReducers from 'util/combineBenchlingReducers';

import reduceMoleculeVersionUIs, {MoleculeVersionUIsState} from './molecules/reduceMoleculeVersionUIs';

export interface ChemistryUIState {
  moleculeVersionUIs: MoleculeVersionUIsState;
}

export default combineBenchlingReducers({
  moleculeVersionUIs: reduceMoleculeVersionUIs,
});
